// A DATE column arrives as a plain `YYYY-MM-DD`, which `new Date()` reads as midnight *UTC*, so
// the local getters answer the previous day west of UTC. A bare date is read field by field.
const PLAIN_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

function toLocalDate(isoDateString) {
    const plain = String(isoDateString).match(PLAIN_DATE);
    return plain
        ? new Date(Number(plain[1]), Number(plain[2]) - 1, Number(plain[3]))
        : new Date(isoDateString);
}

export function formatDate(isoDateString) {
    const date = toLocalDate(isoDateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
}

// Indexed by Date#getDay(), so Sunday first.
const WEEKDAYS = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

/** The German weekday, spelled out rather than taken from `toLocaleDateString`, which without a
 *  locale argument follows the browser's and would hand a visitor "Monday". */
export function weekdayName(isoDateString) {
    if (!isoDateString) return '';
    const date = toLocalDate(isoDateString);
    return Number.isNaN(date.getTime()) ? '' : WEEKDAYS[date.getDay()];
}
